import PropTypes from 'prop-types';
import { flexBrandingDetailsType } from "./flex-branding-details-type";

export const flexDetailsType = PropTypes.shape({
    requested: PropTypes.number.isRequired,
    minimum: PropTypes.number.isRequired,
    maximum: PropTypes.number.isRequired,
    brandingDetails: flexBrandingDetailsType.isRequired
});